module.exports = __webpack_public_path__ + "img/product_91.37a28ee.svg";